import { PUZZLE_TYPES, DIFFICULTY_LEVELS, PUZZLE_TRIGGER_CHANCE, PUZZLE_REWARDS } from './config';
import PuzzleGenerator from './puzzleGenerator';
import PuzzleSolver from './puzzleSolver';

class PuzzleManager {
  constructor() {
    this.generator = new PuzzleGenerator();
    this.solver = new PuzzleSolver();

  }

  // Try to trigger a puzzle - always generates a 4x4 binary puzzle
  tryTriggerPuzzle() {

    
    try {
      // Always generate a 4x4 binary puzzle
      const puzzle = this.generator.generatePuzzle();

      
      if (!puzzle) {
        console.error('PuzzleManager: Failed to generate puzzle');
        return null;
      }
      
      // Add validation methods
      const enhancedPuzzle = {
        ...puzzle,
        validateSolution: (attempt) => this.validateSolution(puzzle, attempt),
        getHint: (attempt) => this.getHint(puzzle, attempt),
        calculateRewards: (timeRemaining) => this.calculateRewards(puzzle, timeRemaining)
      };
      
     
      
      return enhancedPuzzle;
    } catch (error) {
      console.error('PuzzleManager: Error generating puzzle:', error);
      return null;
    }
  }

  // Validate puzzle solution
  validateSolution(puzzle, attempt) {

    const result = this.solver.validateSolution(puzzle, attempt);

    return result;
  }

  // Get hint for current attempt
  getHint(puzzle, attempt) {

    const hint = this.solver.getHint(puzzle, attempt);

    return hint;
  }

  // Calculate rewards for puzzle completion
  calculateRewards(puzzle, timeRemaining) {

    
    // Fixed rewards for binary puzzles
    const baseRewards = {
      qubits: 100,
      multiplier: 1.5
    };
    
    // Time bonus: up to 50% extra rewards if completed quickly
    const timeBonus = timeRemaining / puzzle.timeLimit; // 0 to 1
    const timeBonusMultiplier = 1 + (timeBonus * 0.5);
    
    const rewards = {
      qubits: Math.floor(baseRewards.qubits * timeBonusMultiplier),
      multiplier: baseRewards.multiplier * timeBonusMultiplier
    };
    

    return rewards;
  }
}

export {
  PuzzleManager,
  PUZZLE_TYPES,
  DIFFICULTY_LEVELS,
  PUZZLE_REWARDS
};